<template>
  <div class="contact-page">
    <sub-banner>
      <template v-slot:text>
        <h1 class="">Contact</h1>
      </template>
    </sub-banner>
    <div class="container-xxl py-5" style="margin-top: -100px">
      <div class="container">
        <div class="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s"
             style="max-width: 600px; visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
          <h1 class="display-5 mb-4">Kom in contact met <span class="green-color">Hendri Nagelholt</span></h1>
        </div>
        <div class="wow fadeInUp" data-wow-delay="0.1s"
             style="max-width: 900px; margin: auto">
          <a href="https://maps.app.goo.gl/Nhbp9To2FJdDVCYJA" style="text-decoration: none" target="_blank">
            <div class="bg-light blokje d-flex align-items-center w-100 p-4 mb-4">
              <div class="d-flex flex-shrink-0 align-items-center justify-content-center bg-dark"
                   style="width: 55px; height: 55px;">
                <i class="fa fa-map-marker-alt text-white"></i>
              </div>
              <div class="ms-4">
                <p class="mb-2 fs-5" style="color: #212529">Adres</p>
                <h3 class="mb-0 fs-4">Begoniastraat 17, 8096 XB, Oldebroek</h3>
              </div>
            </div>
          </a>
          <a href="tel:0621420459" style="text-decoration: none" target="_blank">
            <div class="bg-light blokje d-flex align-items-center w-100 p-4 mb-4">
              <div class="d-flex flex-shrink-0 align-items-center justify-content-center bg-dark"
                   style="width: 55px; height: 55px;">
                <i class="fa fa-phone-alt text-white"></i>
              </div>
              <div class="ms-4">
                <p class="mb-2 fs-5" style="color: #212529">Bel mij</p>
                <h3 class="mb-0 fs-4">06-21420459</h3>
              </div>
            </div>
          </a>
          <a href="mailto:info@hnaccountancy.nl" style="text-decoration: none" target="_blank">
            <div class="bg-light blokje d-flex align-items-center w-100 p-4 mb-0">
              <div class="d-flex flex-shrink-0 align-items-center justify-content-center bg-dark"
                   style="width: 55px; height: 55px;">
                <i class="fa fa-envelope-open text-white"></i>
              </div>
              <div class="ms-4">
                <p class="mb-2 fs-5" style="color: #212529">Mail mij</p>
                <h3 class="mb-0 fs-4" style="overflow-wrap: anywhere; line-height: 1;">info@hnaccountancy.nl</h3>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextImage from '@/components/TextImage.vue'
import SubBanner from "@/components/SubBanner";
import ListImage from "@/components/ListImage";

export default {
  name: "Contact",
  components: {
    SubBanner,
    TextImage,
    ListImage
  },
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="scss" scoped>

$gold: #D6AD60;

.contact-title {
  @media (max-width: 700px) {
    font-size: 25px;
    line-height: 30px;
  }
}

.col-lg-6 {
  @media (max-width: 980px) {

    padding: 0 6px !important;
  }
}

.blokje {
  background-color: #ececec !important;
}

</style>
